<div
    nz-tooltip
    [nzTooltipTitle]="name"
    [style]="{ 'border-color': stroke }"
    class="port-circle"
>
</div>
